<script>
import template from './template.html';
import helpers from '@/utils/helpers';
import store from '@/store';
import Menu from '@/shared/menu/store';
import { showPopup } from '@/utils/popup';
import PTJ_QR_REF from '@/views/popupSearch/PTJ_QR_REF/index.vue';
import PTJ_Worker022 from '@/views/popupSearch/PTJ_Worker022/index.vue';

import { mapActions, mapMutations } from 'vuex';
export default {
    name: 'ItemLeftMenu',
    template: template,
    beforeCreate() {
        if (!store.hasModule('Menu')) {
            store.registerModule('Menu', Menu);
        }
    },
    props: {
        item: Object,
        index: Number,
        classMore: {
            type: Object,
            default() {
                return {};
            }
        },
        isChild: {
            type: Boolean,
            default: false
        },
        funcCloseChildMenu: {
            type: Function
        }
    },
    data() {
        return {
            isMobile: helpers.checkIfMobile()
        };
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions('Menu', ['referItem']),
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError',
            'setShowLeftMenu'
        ]),
        ...mapMutations('app', ['setRouteProps']),
        onClickPopup() {
            showPopup({
                component: PTJ_QR_REF,
                dimensions: {
                    width: '70%!important',
                    height: '45%!important'
                },
                options: {
                    showCloseButton: false,
                    showHeader: false
                }
            });
        },
        onClickPopupWorker022() {
            this.setShowLeftMenu(false);
            this.funcCloseChildMenu?.();
            showPopup({
                component: PTJ_Worker022,
                dimensions: {
                    width: '380px',
                    height: 'auto'
                },
                options: {
                    showCloseButton: false,
                    showHeader: false,
                    closeOnOverlay: false
                }
            });
        },

        handleMenuNavigation(menuItem) {
            if (menuItem.name === 'PTJ_Worker022') {
                this.onClickPopupWorker022();
                return;
            }
            if (menuItem.staticFile) {
                window.open('/sample/' + menuItem.staticFile);
                return;
            }
            // If routeProps exist, set them to store before navigation
            if (menuItem.routeProps) {
                const routeName = menuItem.routeNameRelative || menuItem.to.replace('/', ''); // Remove leading slash
                this.setRouteProps({
                    routeName,
                    props: menuItem.routeProps
                });
            }

            // Handle different target types
            if (menuItem.newTab) {
                // Open in new tab/window
                const { href } = this.$router.resolve(menuItem.to);
                window.open(`${window.location.origin}${href}`, '_blank');
            } else {
                // Navigate in same window
                this.$router.push(menuItem.to);
                this.setShowLeftMenu(false);
                this.funcCloseChildMenu();
            }
        }
    }
};
</script>
